module.exports = __webpack_public_path__ + "img/policy.f3d8a862.png";